import { render, staticRenderFns } from "./TimelineAddItemDialog.vue?vue&type=template&id=3395c4a0&scoped=true"
import script from "./TimelineAddItemDialog.vue?vue&type=script&lang=ts"
export * from "./TimelineAddItemDialog.vue?vue&type=script&lang=ts"
import style0 from "./TimelineAddItemDialog.vue?vue&type=style&index=0&id=3395c4a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3395c4a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3395c4a0')) {
      api.createRecord('3395c4a0', component.options)
    } else {
      api.reload('3395c4a0', component.options)
    }
    module.hot.accept("./TimelineAddItemDialog.vue?vue&type=template&id=3395c4a0&scoped=true", function () {
      api.rerender('3395c4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/TimelineAddItemDialog.vue"
export default component.exports